module.exports = __webpack_public_path__ + "img/enterprise-bg.ecf0f51a.png";